import { expose } from 'comlink';
import { collection, getDocs, getFirestore, query, Query } from 'firebase/firestore';
import { AbstractWarehouseSyncStepWorker } from './abstract-warehouse-worker.utils';
import { WarehouseSyncStepTaskContext } from '../executors';
import type { ProgressCallback } from '../executors';
import { LayoutTextSegment } from '../../warehouse/warehouse.dto';
import { LAYOUT_TEXTS_COLLECTION, TEXTS_STORE, WW_WAREHOUSES_COLLECTION, logger } from '@damofire/data-commons';

export class WarehouseLayoutTextStepsWorker extends AbstractWarehouseSyncStepWorker {
  constructor() {
    super(TEXTS_STORE, 'LAYOUT_TEXTS');
  }

  protected async clean(ctx: WarehouseSyncStepTaskContext, onProgress?: (progress: number) => void): Promise<void> {
    logger.debug('WarehouseLayoutTextStepsWorker::clean', { division: ctx.division, category: 'sync' });
    return this.deleteAllDataObsoleteFromStore<LayoutTextSegment>(this.store, ctx, (dto) => dto.divisionId, undefined, onProgress);
  }

  protected async download(ctx: WarehouseSyncStepTaskContext, onProgress?: ProgressCallback): Promise<void> {
    logger.debug('WarehouseLayoutTextStepsWorker::download', { division: ctx.division, category: 'sync' });

    const q: Query = query(collection(getFirestore(), `${WW_WAREHOUSES_COLLECTION}/${ctx.division}/${LAYOUT_TEXTS_COLLECTION}`));
    const layoutTexts = await getDocs(q).then((docs) =>
      docs.docs.map((d) => ({ ...d.data(), divisionId: ctx.division, division: { _id: ctx.division }, _id: d.id, syncId: ctx.syncId })),
    );

    logger.info('Downloaded layout texts from Firestore', { count: layoutTexts.length, category: 'sync' });

    if (!this.shouldStopTask) {
      await this.idbService.updateAll(this.store, layoutTexts).catch(console.error);
      onProgress?.(100, { processed: layoutTexts.length, expected: layoutTexts.length });
    }
  }
}

expose(WarehouseLayoutTextStepsWorker);
